<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <div class="font-weight-bold mb-3">
              こちらの内容でMicrosoft
              Peering向けNAPTを設定します。よろしいですか？<br />
              ※設定反映を行うと数秒程度の通信断が発生します。
            </div>

            <!--仮想ネットワーク-->
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="VPN/VNコード"
                  :value="naptSetting.vpnVnCode"
                />
              </v-col>
            </v-row>

            <!--NAPT用グローバルIP-->
            <v-row>
              <v-col cols="12">
                <app-label-group label="NAPT用グローバルIP">
                  <template #value>
                    <div class="ml-3">
                      <span> 追加グローバルIP数 {{ addNapt }} 個 </span>
                      <div
                        v-for="(item, index) in msNaptGlobalIpList"
                        :key="index"
                      >
                        <span>{{ item.globalIpAddress }}</span>
                      </div>
                      <div v-for="i in addNapt" :key="i">
                        <span>設定完了後にIPが払い出されます</span>
                      </div>
                    </div>
                  </template>
                </app-label-group>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions class="modal-footer">
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import type {
  NaptGlobalIpEntity,
  NatNaptDetailEntity,
} from "@/apis/MSPeeringIpApi";
import { defineComponent } from "vue";

export default defineComponent({
  name: "MSNaptSettingModifyConfirm",
  props: {
    /** 追加グローバルIP数 */
    addNapt: {
      type: Number as PropType<number>,
      required: true,
    },
    /** NAPT用グローバルIP設定情報 */
    naptSetting: {
      type: Object as PropType<NatNaptDetailEntity>,
      required: true,
    },
    /** Microsoft 払出済グローバルIP情報 */
    msNaptGlobalIpList: {
      type: Array as PropType<NaptGlobalIpEntity[]>,
      required: true,
    },
  },
});
</script>
